<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">{{ title }}</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        {{ message }}
      </div>
      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      confirmed: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      newSku: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      formatAttribute (value) {
        if (value.indexOf('|') !== -1) {
          value = value.replace(/\|/g, ', ')
        }

        return value
      },
      confirm () {
        this.$emit('option', true)
        this.confirmed = true
        this.close()
      },
      cancel () {
        this.$emit('option', false)
        this.close()
      },
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    computed: {
      selectedMatch () {
        if (!this.product.selectedMatchSku) {
          return false
        }
        return this.product.availableMatches.find(availableMatch => availableMatch.sku === this.product.selectedMatchSku)
      },
      title () {
        if (this.newSku) {
          return 'Confirmação de novo produto'
        }

        return 'Confirmação de Match'
      },
      message () {
        if (this.newSku) {
          return 'Tem certeza de que deseja criar como um novo produto?'
        }

        return 'Tem certeza de que deseja confirmar o match?'
      }
    },
    watch: {
      isVisible (value) {
        if (value === false && !this.confirmed) {
          this.$emit('option', false)
        }
        this.confirmed = false
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .product-img
    max-width: 75px

  .icon-arrow
    font-size: 25px
    margin: 20px 0
</style>



// WEBPACK FOOTER //
// SelectMatch.vue?c8fe2c76